import ErrorBoundary from '@ms/yammer-libs-error-boundary';
import React, { FC } from 'react';

import { LoadableDogfoodPerfHUD } from './LoadableDogfoodPerfHUD';

export const DogfoodPerfHUDBoundary: FC = () => (
  <ErrorBoundary name="PerfHUD">
    <LoadableDogfoodPerfHUD />
  </ErrorBoundary>
);
